var _circle, _circle2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    stroke: "#05C1A0",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 28C19.25 28.4142 19.5858 28.75 20 28.75C20.4142 28.75 20.75 28.4142 20.75 28L19.25 28ZM20.5303 11.4697C20.2374 11.1768 19.7626 11.1768 19.4697 11.4697L14.6967 16.2426C14.4038 16.5355 14.4038 17.0104 14.6967 17.3033C14.9896 17.5962 15.4645 17.5962 15.7574 17.3033L20 13.0607L24.2426 17.3033C24.5355 17.5962 25.0104 17.5962 25.3033 17.3033C25.5962 17.0104 25.5962 16.5355 25.3033 16.2426L20.5303 11.4697ZM20.75 28L20.75 12L19.25 12L19.25 28L20.75 28Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 28C26.5 28.2761 26.7239 28.5 27 28.5C27.2761 28.5 27.5 28.2761 27.5 28L26.5 28ZM27.3536 18.6464C27.1583 18.4512 26.8417 18.4512 26.6464 18.6464L23.4645 21.8284C23.2692 22.0237 23.2692 22.3403 23.4645 22.5355C23.6597 22.7308 23.9763 22.7308 24.1716 22.5355L27 19.7071L29.8284 22.5355C30.0237 22.7308 30.3403 22.7308 30.5355 22.5355C30.7308 22.3403 30.7308 22.0237 30.5355 21.8284L27.3536 18.6464ZM27.5 28L27.5 19L26.5 19L26.5 28L27.5 28Z",
    fill: "#6E6E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 28C12.5 28.2761 12.7239 28.5 13 28.5C13.2761 28.5 13.5 28.2761 13.5 28L12.5 28ZM13.3536 18.6464C13.1583 18.4512 12.8417 18.4512 12.6464 18.6464L9.46447 21.8284C9.2692 22.0237 9.2692 22.3403 9.46447 22.5355C9.65973 22.7308 9.97631 22.7308 10.1716 22.5355L13 19.7071L15.8284 22.5355C16.0237 22.7308 16.3403 22.7308 16.5355 22.5355C16.7308 22.3403 16.7308 22.0237 16.5355 21.8284L13.3536 18.6464ZM13.5 28L13.5 19L12.5 19L12.5 28L13.5 28Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.50b0b59ead0231c8fc6486553c65ab4d.svg";
export { ForwardRef as ReactComponent };